import { Cushion, FlexContainer, Grid, Typography } from '@pitchero/react-ui';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Trans } from '../../lib/i18n';
import ActivityStreamMessage from '../activity-stream/message';
import { fetchRelatedContentData } from '../../store/activity-stream/actions';
import {
  getRelatedContent,
  hasLoadedRelatedContent,
  isLoadingRelatedContent,
} from '../../store/activity-stream/selectors';

import PlaceholderCard from '../card/placeholder';

const ITEMS_TO_SHOW = 3;

class RelatedContent extends React.Component {
  componentDidMount() {
    this.loadIfRequired();
  }

  loadIfRequired = () => {
    const { clubId, hasLoaded, loadData, messageId } = this.props;

    if (!hasLoaded) {
      loadData(clubId, messageId);
    }
  };

  renderItems = (items) => {
    const { placement } = this.props;
    return items.map((relatedItem) => (
      <ActivityStreamMessage
        message={relatedItem}
        placement={placement}
        stacked="tab-and-up"
        shadow={false}
        key={relatedItem.id}
        imageProps={{ style: { borderRadius: '10px' } }}
        isV2
      />
    ));
  };

  renderPlaceholders = () => {
    const placeholderItems = new Array(ITEMS_TO_SHOW);
    return placeholderItems.map((key) => (
      <PlaceholderCard key={key} stacked="never" shadow={false} />
    ));
  };

  render = () => {
    const { relatedItems, hasLoaded, isLoading } = this.props;

    const items = relatedItems.slice(0, ITEMS_TO_SHOW);

    if (isEmpty(relatedItems) && !isLoading && hasLoaded) {
      return null;
    }

    const showPlaceholder = isLoading || !hasLoaded;

    return (
      <>
        <Cushion bottom="20px" responsive={[{ minWidth: 'fullHeader', props: { bottom: '30px' } }]}>
          <Typography
            preset="name"
            component="div"
            size={16}
            color="#000"
            responsive={[{ minWidth: 'fullHeader', props: { size: 30 } }]}
          >
            <Trans i18nKey="common:news_further_reading">Further Reading</Trans>
          </Typography>
        </Cushion>
        <FlexContainer flexDirection="column" style={{ gap: '30px' }}>
          <Grid
            rowGap="medium"
            responsive={[
              { minWidth: 'fullHeader', props: { columns: '1fr 1fr 1fr', columnGap: 'large' } },
            ]}
          >
            {showPlaceholder ? this.renderPlaceholders() : this.renderItems(items)}
          </Grid>
        </FlexContainer>
      </>
    );
  };
}

RelatedContent.defaultProps = {
  relatedItems: null,
};

RelatedContent.propTypes = {
  clubId: PropTypes.number.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  loadData: PropTypes.func.isRequired,
  messageId: PropTypes.string.isRequired,
  placement: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  relatedItems: PropTypes.arrayOf(PropTypes.shape()),
};

const mapStateToProps = (state, ownProps) => ({
  relatedItems: getRelatedContent(state, ownProps.messageId),
  hasLoaded: hasLoadedRelatedContent(state, ownProps.messageId),
  isLoading: isLoadingRelatedContent(state),
});

const dispatchToProps = {
  loadData: fetchRelatedContentData,
};

export default connect(mapStateToProps, dispatchToProps)(RelatedContent);
